import { Component } from "@angular/core";
import { FieldType, FormGlobalService } from "@kre-form/core";

@Component({
  selector: "kreform-tabular-item",
  template: `
    <kreform-field
      *ngFor="let f of field.fieldGroup"
      [field]="f"
    ></kreform-field>
    <ng-content></ng-content>
  `,
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: "",
  },
})
export class KreFormFieldTabularItem extends FieldType {}
